import { GoogleAnalyticsEventType } from 'enums/GoogleAnalyticsEventType';
import { EnvironmentVariable } from 'enums/curo/EnvironmentVariable';
import { envs } from 'envs';
import { getApplicationSelector } from 'handlers/curo-handlers/selectors';
import { getCurrentApplication } from 'thunks';
import { ICuroApplication } from 'types/curo/CuroApplication';
import { EVENT_CONFIG } from 'utils/generateGoogleEvents';

import { useAppSelector } from './reduxHooks';
import useDispatchWithUnwrap from './useDispatchWithUnwrap';

const logData = (...props: any[])=> {
  if (envs[EnvironmentVariable.Environment] !== 'prod') {
    console.log(...props);
  }
};

const EVENTS_WITH_FETCHING_APP = [
  GoogleAnalyticsEventType.FundedStatus,
  GoogleAnalyticsEventType.OnlineOrigination,
  GoogleAnalyticsEventType.PrequalCompleted,
  GoogleAnalyticsEventType.ApplyProcessBranchOfferGeneric,
  GoogleAnalyticsEventType.AutopayDecision,
];

const useGoogleAnalytics = () => {
  const dispatchWithUnwrap = useDispatchWithUnwrap();
  const application = useAppSelector(getApplicationSelector);

  const pushToDataLayer = (payload: any) => {
    if (payload) {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push(payload);

      logData('DATA LAYER: ', (window as any).dataLayer);
    }
  };

  const trackEvent = async (type: GoogleAnalyticsEventType, extraParams?: Record<string, any>) => {
    let currentApplication = application || {} as ICuroApplication;

    if (EVENTS_WITH_FETCHING_APP.includes(type) || !currentApplication) {
      currentApplication = await dispatchWithUnwrap(getCurrentApplication());
    }

    const eventConfig = EVENT_CONFIG[type];
    
    if (eventConfig) {
      const eventData = eventConfig(currentApplication, extraParams);

      if (eventData) {
        pushToDataLayer(eventData);

        logData('Event -', type, eventData);
      }
    } else {
      pushToDataLayer({ event: type, ...extraParams });

      logData('Event - ', type, extraParams);
    }
  };

  return trackEvent;
};

export default useGoogleAnalytics;
